<ng-container *transloco="let t">
    <div tuiGroup class="w-full max-w-full" style="min-width: min(360px, 100%)" [collapsed]="true">
        <tui-input
            *tuiLet="geocoderResults$ | async as geocoderResults"
            [formControl]="searchCtrl"
            [tuiTextfieldLabelOutside]="false"
            [tuiTextfieldCleaner]="true"
            class="flex-auto shadow-none"
        >
            {{ label || t('delivery_to') }}
            <input tuiTextfield [placeholder]="t('enter_your_address')" />
            <ng-container *ngIf="geocoderResults?.length">
                <tui-data-list *tuiDataList>
                    <button
                        *ngFor="let item of geocoderResults"
                        tuiOption
                        [value]="item.formatted_address"
                        (click)="onSelected(item)"
                    >
                        {{ item.formatted_address }}
                    </button>
                </tui-data-list>
            </ng-container>
        </tui-input>

        <button
            tuiIconButton
            type="button"
            appearance="outline"
            icon="svg::map-pin"
            class="flex-none"
            style="flex: none"
            (click)="getCurrentLocation()"
            [showLoader]="(isLoadingGeocode$ | async) === true"
        ></button>
    </div>
</ng-container>
